<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><a id="ch00_fm04"></a><a id="page_5"></a><img alt="Image" src="images/f0005-01.jpg"/></p>
<p class="paraspaceabove">In memory of the late Dr. Robert C. Atkins, 1930–2003.<br/>Because of his fearless tenacity, millions of us live better lives today.</p>
<p class="paraspaceabove">“If I can see far, it is because I have stood on the shoulders of giants.”</p>
<p class="attribution">—Sir Isaac Newton <a id="page_6"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm04.vue?12c92246